import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { LoadingBackdropIndeterminate } from "../LoadingBackdrop"
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EmailIcon from '@mui/icons-material/Email';
import { Box, Stack } from "@mui/system"
import { send_authorized_request } from "../../Constants/cognito"
import { AXIOS_API_INSTANCE, INVOICE_STATUS_FRIENDLY_NAMES, LONG_DATE_FORMAT, PAYMENT_STATUS_COLOR_MAP } from "../../Constants"
import { ButtonGroup, Chip, CircularProgress, DialogContentText, InputAdornment, Menu, MenuItem, TextField } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { useSnackbar } from 'notistack';
import { useTrackedLocation, useTrackedUser } from "../UserState"
import dayjs from 'dayjs';
import { formatCustomerName, moneyFormat } from "../../Utils"
import ConfirmModal from "../modals/ConfirmModal"
import Alert from '@mui/material/Alert';
import CashCheckPaymentModal from "./modals/CashCheckPaymentModal"
import BlockchypPaymentModal from "./modals/BlockchypPaymentModal"
import BlockchypLinkPaymentModal from "./modals/BlockchypLinkPaymentModal"
import ManualPaymentModal from "./modals/ManualPaymentModal"
import CustomerModal from "../CustomerModal"
import ItemizedInvoiceModal from "./modals/ItemizedInvoiceModal"
import InputModal from "../modals/InputModal"
import { findLocation, useLocations } from "../ReactQuery/QueryLocations"
import CardPointePaymentModal from "./modals/CardPointePaymentModal"
import ManualPaymentEditModal from "./modals/ManualPaymentEditModal"
import SendQuoteInvoiceModal from "../Service/Modals/SendQuoteInvoiceModal"

const payment_remaining_text = (invoice, payment_remaining) => {
    if (invoice.status === 'DEPOSIT') {
        return moneyFormat(Math.round(payment_remaining * 100) / 100)
    } else if (invoice.status === 'ON_HOLD') {
        return '-.--'
    } else {
        return moneyFormat(Math.round(payment_remaining * 100) / 100)
    }
}

export default function PaymentPage({ open, invoice, location_id, sendUpdate, customer, serviceOrder = undefined }) {
    const { enqueueSnackbar } = useSnackbar();
    const [selectedLocation,] = useTrackedLocation();
    const [my_user,] = useTrackedUser();
    const { data: locations, } = useLocations();
    const [checkoutUpdatingStep, setCheckoutUpdatingStep] = React.useState(0)
    const [receiptSendingStep, setReceiptSendingStep] = React.useState(0)
    const [receiptPreviewStep, setReceiptPreviewStep] = React.useState(0)
    const [refreshTimer, setRefreshTimer] = React.useState(undefined)
    const [paymentBeingAdjusted, setPaymentBeingAdjusted] = React.useState(undefined)
    const [paymentAdjustAmountMax, setPaymentAdjustAmountMax] = React.useState(0)
    const [paymentAdjustAmount, setPaymentAdjustAmount] = React.useState(0)
    const [paymentAdjustDialogOpen, setPaymentAdjustDialogOpen] = React.useState(false)
    const [paymentOptionsMenuAnchorElement, setPaymentOptionsMenuAnchorElement] = React.useState(null);
    const [paymentOptionsMenuItemOpen, setPaymentOptionsMenuItemOpen] = React.useState(null);
    const [cashCheckPaymentModalOpen, setCashCheckPaymentModalOpen] = React.useState(false)
    const [manualPaymentModalOpen, setManualPaymentModalOpen] = React.useState(false)
    const [manualPaymentEditModalPayment, setManualPaymentEditModalPayment] = React.useState(false)
    const [blockchypPaymentModalOpen, setBlockchypPaymentModalOpen] = React.useState(false)
    const [blockchypLinkPaymentModalOpen, setBlockchypLinkPaymentModalOpen] = React.useState(false)
    const [cardPointePaymentModalOpen, setCardPointePaymentModalOpen] = React.useState(false)
    const [sendQuoteInvoiceModalOpen, setSendQuoteInvoiceModalOpen] = React.useState(false)
    const [confirmation, setConfirmation] = React.useState({
        open: false,
        text: '',
        callback: null
    })
    const [inputModal, setInputModal] = React.useState({
        open: false,
        text: '',
        callback: null
    })
    const [customerModalOpen, setCustomerModalOpen] = React.useState(false)
    const [itemizedModalOpen, setItemizedModalOpen] = React.useState(false)
    const depositPayment = invoice.status === 'DEPOSIT'
    const activePayment = Boolean((invoice?.invoice_payments || []).find((item) => ['PROCESSING', 'LINK-SENT'].includes(item.status)))
    const canPay = !activePayment && ['DEPOSIT', 'PAYMENT_PENDING'].includes(invoice.status)
    const invoice_or_receipt = invoice?.status === 'PAID' ? 'Receipt' : 'Invoice'


    console.log("RENDER PAYMENT PAGE")

    const editDeposit = () => {
        setInputModal({
            open: true,
            title: 'Edit Deposit Amount',
            label: 'Deposit Amount',
            isMoney: true,
            defaultInput: invoice.deposit,
            callback: (result, input) => {
                if (result) {
                    send_authorized_request(() => AXIOS_API_INSTANCE.post(`invoices/${invoice.id}/change_deposit`, { deposit: input }).then(() => {
                        enqueueSnackbar('Successfully updated deposit', { variant: 'success' })
                        sendUpdate(true)
                    }).catch((error) => {
                        enqueueSnackbar(`Failed to update deposit <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                    }))
                }
                setInputModal({ ...inputModal, open: false })
            }
        })
    }

    const handleChange = (prop) => (event, sometimes_new_value) => {
        if (["paymentAdjustAmount"].includes(prop)) {
            setPaymentAdjustAmount(Math.min(Math.round(parseFloat(event.target.value) * 100) / 100, paymentAdjustAmountMax))
        }
    }
    const openPaymentOptionsMenu = (event, item_id) => {
        setPaymentOptionsMenuAnchorElement(event.currentTarget.parentElement)
        setPaymentOptionsMenuItemOpen(item_id)
    }

    const paymentAction = (payment_id, action, data = {}, confirm = false, confirm_text = '') => {
        const func = () => send_authorized_request(() => {
            setCheckoutUpdatingStep(1)
            AXIOS_API_INSTANCE.post(`invoicepayments/${payment_id}/${action}`, data).then(() => {
                setCheckoutUpdatingStep(0)
                enqueueSnackbar('Successfully updated payment', { variant: 'success' })
                sendUpdate(true)
                setPaymentOptionsMenuItemOpen(null)
            }).catch((error) => {
                setCheckoutUpdatingStep(0)
                enqueueSnackbar(`Failed to update payment <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        })

        if (confirm) {
            setConfirmation({
                open: true,
                text: confirm_text,
                callback: (confirmation) => {
                    if (confirmation) {
                        func()
                    }
                    setConfirmation({ text: '', open: false })
                }
            })
        } else {
            func()
        }
    }

    const closePaymentModal = (setter) => (result) => {
        if (result) {
            sendUpdate(true)
        }
        setter(false)
    }

    const openPaymentAdjustment = (payment_object) => {
        setPaymentBeingAdjusted(payment_object)
        setPaymentAdjustDialogOpen(true)
        const currently_paid = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'PAID').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
        const currently_hold = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'HOLD').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
        payment_remaining = (invoice.total_cost || 0) - currently_paid - currently_hold
        setPaymentAdjustAmount(payment_remaining + payment_object.total_cost)
        setPaymentAdjustAmountMax(payment_remaining + payment_object.total_cost)
    }

    const closePaymentAdjustment = () => {
        setPaymentAdjustDialogOpen(false)
        setPaymentBeingAdjusted(undefined)
    }

    const submitPaymentAdjustment = () => {
        setPaymentAdjustDialogOpen(false)
        paymentAction(paymentBeingAdjusted.id, 'blockchyp_capture_preauth', { 'payment_amount': paymentAdjustAmount })
    }

    const previewInvoice = () => {
        setReceiptPreviewStep(1)
        send_authorized_request(() => AXIOS_API_INSTANCE.post(`invoices/${invoice.id}/preview_receipt`, {}).then((response) => {
            setReceiptPreviewStep(0)
            const url = response.data.data.replace(/.*\/\/[^/]*/, window.location.origin)
            window.open(url, '_blank').focus()
        }).catch((error) => {
            setReceiptPreviewStep(0)
            enqueueSnackbar(`Failed to preview quote: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
        }))
    }

    const currently_paid = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'PAID').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
    const currently_hold = Math.round((invoice?.invoice_payments || []).filter((item) => item.status === 'HOLD').reduce((accumulator, item) => accumulator + item.total_cost, 0) * 100) / 100
    var payment_remaining = 0
    // DEPOSIT
    if (depositPayment) {
        payment_remaining = invoice.deposit - currently_paid - currently_hold
    }
    // REGULAR PAYMENT
    else {
        payment_remaining = (invoice?.total_cost || 0) - currently_paid - currently_hold
    }
    React.useEffect(() => {
        if (open) {
            const any_processing_payments = Boolean((invoice?.invoice_payments || []).find((item) => ['PROCESSING'].includes(item.status)))
            if (any_processing_payments) {
                clearTimeout(refreshTimer)
                setRefreshTimer(setTimeout(() => { if (open) sendUpdate(true) }, 10 * 1000))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, invoice])

    if (invoice === undefined || invoice === null) {
        return (<Box></Box>)
    }

    return (
        (<React.Fragment>
            <LoadingBackdropIndeterminate
                open={checkoutUpdatingStep > 0}
                text={"Updating Payment"}
            />
            <LoadingBackdropIndeterminate
                open={receiptSendingStep > 0}
                text={"Sending Receipt"}
            />
            <LoadingBackdropIndeterminate
                open={receiptPreviewStep > 0}
                text={"Generating Preview"}
            />
            <Box>
                <Grid container>
                    <Grid container alignItems={"center"} columns={{ xs: 6, sm: 12 }} rowSpacing={1} size={6}>
                        <Grid size={6}>
                            <h3>Invoice Details</h3>
                            <span>Invoice: #{invoice.id}</span>
                            <br />
                            <span>Invoice Status: {INVOICE_STATUS_FRIENDLY_NAMES[invoice.status]}</span>
                            <br />
                            <span>Customer:</span><Button onClick={() => setCustomerModalOpen(true)}>{formatCustomerName(customer)}</Button>
                        </Grid>
                        <Grid container size={6}>
                            <Grid container size={12} spacing={1}>
                                <Grid size="auto">
                                    <Button color='primary' variant='contained' disabled={!['PAYMENT_PENDING', 'PAID'].includes(invoice.status)} onClick={() => setSendQuoteInvoiceModalOpen(true)}>
                                        Send {invoice.status === 'PAID' ? 'Receipt' : 'Invoice'}
                                    </Button>
                                </Grid>
                                <Grid size="auto">
                                    <Button onClick={previewInvoice} variant="outlined" color="primary" disabled={!['PAYMENT_PENDING', 'PAID'].includes(invoice.status)}>
                                        <span>Preview {invoice.status === 'PAID' ? 'Receipt' : 'Invoice'}</span>
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <Button color='primary' variant='contained' disabled={!['PAYMENT_PENDING', 'PAID'].includes(invoice.status)} onClick={() => setItemizedModalOpen(true)}>
                                    Itemized View
                                </Button>
                            </Grid>
                            {invoice.status === 'DEPOSIT' &&
                                <Grid size={12}>
                                    <Button color='primary' variant='contained' onClick={editDeposit}>
                                        Edit Deposit
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    <Grid size={6}>
                        <h3 style={{ textAlign: 'center' }}>Amount Due: ${payment_remaining_text(invoice, payment_remaining)}</h3>
                        {selectedLocation?.id === "all" &&
                            <Box sx={{ m: 1, ml: 0 }}>
                                <Alert severity="error">No Location Selected</Alert>
                            </Box>
                        }
                        {selectedLocation?.id !== "all" &&
                            <Box>
                                {selectedLocation?.id !== location_id &&
                                    <Box sx={{ m: 1, ml: 0 }}>
                                        <Alert severity="warning">Different Location Selected</Alert>
                                    </Box>
                                }
                                <Grid container spacing={2} justifyContent="space-around">
                                    {selectedLocation?.allow_cash &&
                                        <Grid size="auto">
                                            <Button variant="contained" color="primary" disabled={!canPay} onClick={() => setCashCheckPaymentModalOpen(true)} sx={{ minHeight: '65px' }}>
                                                <LocalAtmIcon /> <Box sx={{ pl: 1 }}>Cash/Check</Box>
                                            </Button>
                                        </Grid>
                                    }
                                    {selectedLocation?.integrations?.BLOCKCHYP &&
                                        <Grid size="auto">
                                            <Button variant="contained" disabled={!canPay} color="primary" onClick={() => setBlockchypPaymentModalOpen(true)} sx={{ minHeight: '65px' }}>
                                                <CreditCardIcon /> <Box sx={{ pl: 1 }}>BlockChyp</Box>
                                            </Button>
                                        </Grid>
                                    }
                                    {selectedLocation?.integrations?.BLOCKCHYP && selectedLocation?.integrations?.BLOCKCHYP.ALLOW_EMAIL &&
                                        <Grid size="auto">
                                            <Button variant="contained" disabled={!canPay} color="primary" onClick={() => setBlockchypLinkPaymentModalOpen(true)} sx={{ minHeight: '65px' }}>
                                                <EmailIcon /> <Box sx={{ pl: 1 }}>BlockChyp Email</Box>
                                            </Button>
                                        </Grid>
                                    }
                                    {selectedLocation?.integrations?.CARDPOINTE &&
                                        <Grid size="auto">
                                            <Button variant="contained" disabled={!canPay} color="primary" onClick={() => setCardPointePaymentModalOpen(true)} sx={{ minHeight: '65px' }}>
                                                <CreditCardIcon /> <Box sx={{ pl: 1 }}>CardPointe</Box>
                                            </Button>
                                        </Grid>
                                    }
                                    <Grid size="auto">
                                        <Button variant="contained" color="primary" disabled={!canPay} onClick={() => setManualPaymentModalOpen(true)} sx={{ minHeight: '65px' }}>
                                            Manual
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Stack direction="row" spacing={2}>
                                </Stack>
                            </Box>
                        }
                    </Grid>
                </Grid>

                <Box sx={{ backgroundColor: 'lightgrey', border: '1px solid grey', paddingLeft: '5px', marginTop: '50px', marginBottom: '5px' }}>
                    <span><b>Invoice Total: ${payment_remaining_text(invoice, depositPayment ? invoice.deposit : invoice.total_cost)}</b></span>
                </Box>
                <Grid container spacing={1} sx={{ width: '100%' }}>
                    {
                        (invoice.invoice_payments.sort((a, b) => dayjs.utc(a.date_created).unix() - dayjs.utc(b.date_created).unix()) || []).map((item) => {
                            return (
                                (<Grid container alignItems="center" key={item.id} size={12}>
                                    <Grid size={2}>
                                        <span>${moneyFormat(item.total_cost)}</span>
                                    </Grid>
                                    <Grid size={3}>
                                        <span>{dayjs.utc(item.date_created).local().format(LONG_DATE_FORMAT)}</span>
                                    </Grid>
                                    <Grid size={3}>
                                        <span><Chip label={`${item.payment_type} - ${item.status}`} color={PAYMENT_STATUS_COLOR_MAP[item.status]} />{['PROCESSING'].includes(item.status) && <CircularProgress />}</span>
                                    </Grid>
                                    <Grid container size={4} justifyContent={'flex-end'} spacing={1}>
                                        {['MANUAL'].includes(item.payment_type) &&
                                            <React.Fragment>
                                                <Grid size="grow">
                                                    <span>Description: {item.payment_data?.[0]?.description}</span>
                                                </Grid>
                                                <Grid size="auto">
                                                    <Button variant='contained' color='warning' onClick={() => setManualPaymentEditModalPayment(item)}>Edit</Button>
                                                </Grid>
                                            </React.Fragment>
                                        }
                                        {['BLOCKCHYP'].includes(item.payment_type) && item.status === 'HOLD' &&
                                            <Grid size="auto">
                                                <ButtonGroup color='primary' variant='contained'>
                                                    <Button onClick={() => paymentAction(item.id, 'blockchyp_capture_preauth', { 'payment_amount': item.total_cost })}>Clear</Button>
                                                    <Button sx={{ p: '6px' }} onClick={(event) => openPaymentOptionsMenu(event, item.id)}><ArrowDropDownIcon /></Button>
                                                </ButtonGroup>
                                                <Menu
                                                    id={item.id + '-paymentoptionsmenu'}
                                                    anchorEl={paymentOptionsMenuAnchorElement}
                                                    open={paymentOptionsMenuItemOpen === item.id}
                                                    onClose={() => setPaymentOptionsMenuItemOpen(null)}
                                                    slotProps={{
                                                        list: {
                                                            'aria-labelledby': 'basic-button',
                                                        }
                                                    }}
                                                >
                                                    <MenuItem onClick={() => openPaymentAdjustment(item)}>Adjust</MenuItem>
                                                    <MenuItem onClick={() => paymentAction(item.id, 'blockchyp_refund', { refund_amount: item.total_cost }, true, 'Are you sure you want to cancel this preauthorization?')}>Cancel</MenuItem>
                                                </Menu>
                                            </Grid>
                                        }
                                        {['BLOCKCHYP-URL'].includes(item.payment_type) && item.status === 'LINK-SENT' &&
                                            <Grid size="auto">
                                                <ButtonGroup color='primary' variant='contained'>
                                                    <Button onClick={() => paymentAction(item.id, 'blockchyp_link_resend_link')}>Resend Email</Button>
                                                    <Button sx={{ p: '6px' }} onClick={(event) => openPaymentOptionsMenu(event, item.id)}><ArrowDropDownIcon /></Button>
                                                </ButtonGroup>
                                                <Menu
                                                    id={item.id + '-paymentoptionsmenu'}
                                                    anchorEl={paymentOptionsMenuAnchorElement}
                                                    open={paymentOptionsMenuItemOpen === item.id}
                                                    onClose={() => setPaymentOptionsMenuItemOpen(null)}
                                                    slotProps={{
                                                        list: {
                                                            'aria-labelledby': 'basic-button',
                                                        }
                                                    }}
                                                >
                                                    <MenuItem onClick={() => paymentAction(item.id, 'blockchyp_link_status')}>Sync</MenuItem>
                                                    <MenuItem onClick={() => paymentAction(item.id, 'blockchyp_link_cancel_link', {}, true, 'Are you sure you want to cancel this payment link?')}>Cancel</MenuItem>
                                                </Menu>
                                            </Grid>
                                        }
                                        {['BLOCKCHYP', 'BLOCKCHYP-URL'].includes(item.payment_type) && item.status === 'PAID' &&
                                            <Grid size="auto">
                                                <Button variant='contained' color='error' onClick={() => paymentAction(item.id, 'blockchyp_refund', { refund_amount: item.total_cost }, true, 'Are you sure you want to refund this payment?')}>Refund</Button>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>)
                            );
                        })
                    }
                </Grid>
                {
                    paymentBeingAdjusted && <Dialog open={paymentAdjustDialogOpen} onClose={closePaymentAdjustment}>
                        <DialogTitle>Adjust Payment</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                This will complete the payment transaction with the new value
                            </DialogContentText>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="paymentamount"
                                label="Payment Amount"
                                type="number"
                                fullWidth
                                variant="standard"
                                value={Math.round(paymentAdjustAmount * 100) / 100}
                                onChange={handleChange("paymentAdjustAmount")}
                                slotProps={{
                                    input: {
                                        inputProps: { min: Math.min(0.01, paymentAdjustAmountMax), max: paymentAdjustAmountMax },
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {<AttachMoneyIcon />}
                                            </InputAdornment>
                                        ),
                                    }
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={closePaymentAdjustment}>Cancel</Button>
                            <Button onClick={submitPaymentAdjustment}>Submit</Button>
                        </DialogActions>
                    </Dialog>
                }
                <CustomerModal
                    customer={customer}
                    open={customerModalOpen}
                    closeModal={(changes) => {
                        setCustomerModalOpen(false)
                        if (changes) {
                            sendUpdate(true)
                        }
                    }}
                />
                <ConfirmModal
                    {...confirmation}
                />
                <CashCheckPaymentModal
                    open={cashCheckPaymentModalOpen}
                    closeModal={closePaymentModal(setCashCheckPaymentModalOpen)}
                    invoice={invoice}
                    amount={payment_remaining}
                />
                <ManualPaymentModal
                    open={manualPaymentModalOpen}
                    closeModal={closePaymentModal(setManualPaymentModalOpen)}
                    invoice={invoice}
                    amount={payment_remaining}
                />
                <ManualPaymentEditModal
                    open={manualPaymentEditModalPayment !== false}
                    closeModal={closePaymentModal(setManualPaymentEditModalPayment)}
                    invoice={invoice}
                    invoicePayment={manualPaymentEditModalPayment}
                />
                <BlockchypPaymentModal
                    open={blockchypPaymentModalOpen}
                    closeModal={closePaymentModal(setBlockchypPaymentModalOpen)}
                    invoice={invoice}
                    amount={payment_remaining}
                />
                <BlockchypLinkPaymentModal
                    open={blockchypLinkPaymentModalOpen}
                    closeModal={closePaymentModal(setBlockchypLinkPaymentModalOpen)}
                    invoice={invoice}
                    customer={customer}
                    amount={payment_remaining}
                />
                <CardPointePaymentModal
                    open={cardPointePaymentModalOpen}
                    closeModal={closePaymentModal(setCardPointePaymentModalOpen)}
                    invoice={invoice}
                    amount={payment_remaining}
                />
                <ItemizedInvoiceModal
                    open={itemizedModalOpen}
                    closeModal={() => setItemizedModalOpen(false)}
                    invoice={invoice}
                    serviceOrder={serviceOrder}
                />
                <SendQuoteInvoiceModal
                    open={sendQuoteInvoiceModalOpen}
                    serviceOrder={serviceOrder}
                    title={`Send ${invoice_or_receipt} To`}
                    defaultTextMessage={findLocation(locations, serviceOrder.location_id)?.service_configs?.invoice_text ?? ''}
                    defaultEmailMessage={findLocation(locations, serviceOrder.location_id)?.service_configs?.invoice_email ?? ''}
                    text_hint={"Link will be added to the end of the message."}
                    extra_text_character_count={` https://api.profitmaxprosuite.com/${my_user.client.id}/s/aaaabbbb`.length}
                    closeModal={(type, destination, message) => {
                        setSendQuoteInvoiceModalOpen(false)
                        if (type) {
                            setReceiptSendingStep(1)
                            send_authorized_request(() => AXIOS_API_INSTANCE.post(`invoices/${invoice.id}/send_receipt`, { destination_type: type, destination: destination, custom_message: message }).then(() => {
                                setReceiptSendingStep(0)
                                enqueueSnackbar(`Successfully sent receipt to ${destination}`, { variant: 'success' })
                            }).catch((error) => {
                                console.log(error)
                                setReceiptSendingStep(0)
                                enqueueSnackbar(`Failed to send receipt <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                            }))
                        }
                    }}
                />
                <InputModal
                    {...inputModal}
                />
            </Box>
        </React.Fragment >)
    );
}
